module.exports = __webpack_public_path__ + "img/banner_img_2.efa2d19c.jpg";